module.exports = function() {
  return new Worker("/" + "c790241c3ef33591aae4.worker.js");
};